'use client';
import { jsx } from 'react/jsx-runtime';
import { factory, useProps, Box } from '@mantine/core';
import { useRichTextEditorContext } from '../RichTextEditor.context.mjs';
import classes from '../RichTextEditor.module.css.mjs';

const defaultProps = {};
const RichTextEditorControlsGroup = factory(
  (_props, ref) => {
    const props = useProps("RichTextEditorControlsGroup", defaultProps, _props);
    const { classNames, className, style, styles, vars, variant, ...others } = props;
    const ctx = useRichTextEditorContext();
    return /* @__PURE__ */ jsx(
      Box,
      {
        ref,
        variant: variant || ctx.variant,
        ...ctx.getStyles("controlsGroup", { className, style, styles, classNames }),
        ...others
      }
    );
  }
);
RichTextEditorControlsGroup.classes = classes;
RichTextEditorControlsGroup.displayName = "@mantine/tiptap/RichTextEditorControlsGroup";

export { RichTextEditorControlsGroup };
//# sourceMappingURL=RichTextEditorControlsGroup.mjs.map
